import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { PresentingSection } from './components/PresentingSection';
import { DiscoverSection } from './components/DiscoverSection';
import { AudienceSection } from './components/AudienceSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0f] text-white font-sans selection:bg-blue-500/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPointsSection data-id="element-2" />
      <PresentingSection data-id="element-3" />
      <DiscoverSection data-id="element-4" />
      <AudienceSection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}